<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="pt01">
<div class="figure">
<p class="fig"><a id="pg1"><img alt="" height="30" src="images/eer-kaiulani-ornament.jpg" width="61"/></a></p><a id="pg1">
</a></div><a id="pg1">
<p class="pt">PRINCESS KA‘IULANI</p>
</a></div><a id="pg1">
</a></div><a id="pg1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0012.vue?a8fe66a2